import { createContext, useState } from "react";

export const ModalContext = createContext();

export const ModalProvider = ({ children }) => {
  const [show, setShow] = useState(false);
  const [title, setTitle] = useState("");
  const [headerIcon, setHeaderIcon] = useState(null);
  const [bodyWithFooter, setBodyWithFooter] = useState(null);
  const [onBackdropClick, setOnBackdropClick] = useState(null);
  const [closeIconVis, setCloseIconVis] = useState(true);

  return (
    <ModalContext.Provider
      value={{
        show,
        setShow,
        title,
        setTitle,
        bodyWithFooter,
        setBodyWithFooter,
        onBackdropClick,
        setOnBackdropClick,
        headerIcon,
        setHeaderIcon,
        closeIconVis,
        setCloseIconVis,
      }}
    >
      {children}
    </ModalContext.Provider>
  );
};
